<template>
    <div>
      <law-ledes-form ref="lawLedesFormModal"></law-ledes-form>
      <b-row v-if="this.lawClientId > 0" class="mb-1">
        <b-col class="col-12 d-flex align-items-center justify-content-between flex-wrap">
          <div class="d-flex align-items-center">
            <strong class="mr-1">{{ $t('clientsInvoiceCode.invoice_code_status') }}:</strong>
            <b-badge :variant="isCustom ? 'primary' : 'secondary'">{{ isCustom ? $t('clientsInvoiceCode.custom') : $t('clientsInvoiceCode.normal') }}</b-badge>
          </div>
          <div>
            <b-button v-if="!isCustom" size="sm" variant="outline-primary" @click="makeCustom()">{{ $t('clientsInvoiceCode.make_custom') }}</b-button>
            <b-button v-else size="sm" variant="outline-secondary" @click="makeNormal()">{{ $t('clientsInvoiceCode.make_normal') }}</b-button>
          </div>
        </b-col>
      </b-row>
      <law-ledes-service-list v-if="isCustom" :lawLedesId="lawLedesId" :clientAccountingId="clientAccountingId" :onRowsLoaded="onCustomCodesLoaded"></law-ledes-service-list>
      <template v-else>
      <invoice-code-report-detail-form :getClientsInvoiceCodeList="getClientsInvoiceCodeList" ref="invoiceCodeReportDetailFormModal"></invoice-code-report-detail-form>
      <b-row>
        <b-col class="col-12">
          <div style="float:left;" class="custom-search d-flex justify-content-end">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-form-input size="sm" v-model="searchTerm" :placeholder="$t('others.search')" type="text"
                  class="d-inline-block" />
              </div>
            </b-form-group>
          </div>

          <div v-if="this.lawClientId == 0" style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" class="mr-1" size="sm" variant="outline-secondary" @click="getInfo(0)">{{ $t('others.add') }}</b-button>
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="exportExcel()">{{ $t('others.excel') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table
      id="clientsInvoiceCodeTable"
      ref="clientsInvoiceCodeTable" 
      :columns="columns" 
      :rows="rows" 
      styleClass="vgt-table condensed tableSize"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" 
        theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'lawServiceType'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.service_type') }}
            </span>
            <span v-else-if="props.column.field === 'lawCostingType'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.costing_type') }}
            </span>
            <span v-else-if="props.column.field === 'code'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.code') }}
            </span>
            <span v-else-if="props.column.field === 'name'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.name') }}
            </span>
            <span v-else-if="props.column.field === 'description'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.description') }}
            </span>
            <span v-else-if="props.column.field === 'vatRate'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.vat_rate') }}
            </span>
            <span v-else-if="props.column.field === 'accountingNo'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.accounting_no') }}
            </span>
            <span v-else-if="props.column.field === 'accountingDescription'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.accounting_description') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <!-- Column: Description -->
          <span v-if="props.column.field === 'description'">
            <div v-b-tooltip.hover="{ title: props.row.description, customClass: 'wh-tooltip' }" class="wh-clamp-2">{{ props.row.description }}</div>
          </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }} </span>
                <b-form-select v-model="pageLength" :options="['10', '25', '50', '100']" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
              <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
            </div>
            <div>
             <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                <template #prev-text>
                 <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                 <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
             </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
      </template>
    </div>
  </template>

  <script>
  export default {
    props: {
      lawClientId: {type:Number}
    },
    mounted(){
      this.getClientsInvoiceCodeList();
      this.getInvoiceCodeStatus();
    },
    data() {
      return {
        pageLength: 50,
        dir: false,
        clientsInvoiceCodeList: '',
        isCustom: false,
        clientAccountingId: 0,
        lawLedesId: 0,
        agentName: '',
        accountingCode: '',
        customCodeCount: 0,
        columns: [
            {
                label: this.$t('invoiceCodeReport.code'),
                field: `code`,
            },
            {
                label: this.$t('invoiceCodeReport.name'),
                field: `name`,
            },
            {
                label: this.$t('invoiceCodeReport.service_type'),
                field: `serviceType`,
            },
            {
                label: this.$t('invoiceCodeReport.description'),
                field: `description`,
            },
        ],
        rows: [],
        searchTerm: '',
      }
    },
    computed: {
      hasEmptyCustomCodes() {
        return this.isCustom && this.customCodeCount === 0
      },
    },
    methods: {
      onCustomCodesLoaded(count) {
        this.customCodeCount = count
      },
      async getInfo(id) {
        this.$refs.invoiceCodeReportDetailFormModal.showInfo(id, this.lawClientId)
      },
      getInvoiceCodeStatus() {
        if (!(this.lawClientId > 0)) {
          return
        }
        const data = { id: this.lawClientId }
        const controller = { name: 'LawLedes', actionName: 'GetInvoiceCodeStatusByLawClientId' }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          if (response.data.resultStatus == true) {
            this.clientAccountingId = response.data.clientAccountingId
            this.lawLedesId = response.data.lawLedesId
            this.customCodeCount = 0
            this.isCustom = response.data.isCustom
            this.agentName = response.data.agentName
            this.accountingCode = response.data.accountingCode
          } else {
            this.$WarningAlert(response.data.resultMessage)
          }
        })
      },
      makeCustom() {
        if (!(this.clientAccountingId > 0)) {
          this.$WarningAlert(this.$t('clientsInvoiceCode.no_accounting_found'))
          return
        }
        if (this.lawLedesId > 0) {
          const data = { id: this.lawLedesId }
          const controller = { name: 'LawLedes', actionName: 'ReactivateLawLedes' }
          const payload = { data: data, controller: controller }
          this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
            if (response.data.resultStatus == true) {
              this.getInvoiceCodeStatus()
            } else {
              this.$WarningAlert(response.data.resultMessage)
            }
          })
        } else {
          this.$refs.lawLedesFormModal.showForClientAccounting(this.clientAccountingId, this.agentName, this.accountingCode, () => {
            this.getInvoiceCodeStatus()
          })
        }
      },
      makeNormal() {
        this.$PrivateConfirm(
          this.$t('clientsInvoiceCode.make_normal_confirm_title'),
          this.$t('clientsInvoiceCode.make_normal_confirm_text'),
          'warning',
          this.$t('others.ok_title'),
          this.$t('others.cancel_title')
        ).then(result => {
          if (result.value) {
            const data = { id: this.lawLedesId }
            const controller = { name: 'LawLedes' }
            const payload = { data: data, controller: controller }
            this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
              if (response.data.resultStatus == true) {
                this.getInvoiceCodeStatus()
              } else {
                this.$WarningAlert(response.data.resultMessage)
              }
            })
          }
        })
      },
      getClientsInvoiceCodeList() {
        this.rows = []
        const data = { id: 0 }
        const controller = { name: 'LawService', actionName: 'GetLawServiceListByClientAccountingId' }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          if (response.data.resultStatus == true) {
            response.data.lawServiceList.forEach(element => {
                this.rows.push(element)
            })
          }
          else {
            this.$WarningAlert(response.data.resultMessage)
          }
        }
        )
      },
    },
  }
  </script>
  <style lang="scss" >
    .tableSize {
      font-size: 13px!important;
      border-collapse: collapse;
      width: 100%;
      max-width: 100%;
      table-layout: auto;
  }
  </style>
  